import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
	BsDatabaseFillGear,
	GrDocumentUpdate,
	GrDocumentTime,
	MdDashboard,
	FiMenu,
	FiChevronLeft,
} from '../../Data/Icons';

function SideBar() {
	const [dropdownState, setDropdownState] = useState({
		MasterExpences: false,
	});
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
	const [isMobileOpen, setIsMobileOpen] = useState(false);
	const location = useLocation();

	const toggleDropdown = (key) => {
		setDropdownState((prevState) => ({
			...prevState,
			[key]: !prevState[key],
		}));
	};

	const isActive = (path) => location.pathname === path;

	const toggleSidebar = () => {
		setIsSidebarCollapsed(!isSidebarCollapsed);
	};

	const toggleMobileSidebar = () => {
		setIsMobileOpen(!isMobileOpen);
	};

	return (
		<div className='flex'>
			{/* Mobile Menu Icon */}
			<button
				onClick={toggleMobileSidebar}
				className='fixed top-4 left-4 z-50 p-2 bg-gray-200 rounded-md shadow-md md:hidden'>
				<FiMenu className='text-2xl' />
			</button>

			{/* Sidebar */}
			<div
				className={`fixed top-0 left-0 z-50 h-full bg-[#fff] shadow-lg transition-all overflow-y-auto scrollbar-hide 
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'} 
          md:translate-x-0 ${isSidebarCollapsed ? 'w-20' : 'w-60'}`}>
				{/* Toggle Sidebar Button */}
				<button
					onClick={toggleSidebar}
					className='absolute top-4 right-4  p-1 rounded-md bg-[#213555] hidden md:block '>
					<FiChevronLeft className='text-xl text-white' />
				</button>

				{/* Sidebar Links */}
				<nav className='p-4'>
					<ul>
						<li>
							<Link
								to='/dashboard'
								className={`flex items-center p-1 rounded-lg transition duration-200 mt-10
                  ${isActive('/dashboard') ? 'bg-[#A9C46C] text-white' : 'hover:bg-white text-[#A9C46C]'}`}>
								<MdDashboard className='text-2xl' />
								{!isSidebarCollapsed && <span className='ml-2 text-lg'>Dashboard</span>}
							</Link>
						</li>

						{/* Dropdown Section */}
						<li>
							<div
								onClick={() => toggleDropdown('MasterExpences')}
								className={`flex items-center justify-between p-2 mt-4 cursor-pointer rounded-lg transition duration-200 
                  ${dropdownState.MasterExpences ? 'bg-[#A9C46C] text-white' : 'hover:bg-white text-gray-700'}`}>
								<span className='flex items-center'>
									<BsDatabaseFillGear className='text-2xl' />
									{!isSidebarCollapsed && <span className='ml-2 text-lg'>Manage Products</span>}
								</span>
								{!isSidebarCollapsed && (
									<svg
										xmlns='http://www.w3.org/2000/svg'
										className='w-4 h-4'
										fill='none'
										viewBox='0 0 24 24'
										stroke='currentColor'>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth={2}
											d={dropdownState.MasterExpences ? 'M19 9l-7 7-7-7' : 'M9 19l7-7-7-7'}
										/>
									</svg>
								)}
							</div>

							{dropdownState.MasterExpences && (
								<ul className='bg-white rounded-lg mt-2'>
									<li>
										<Link to='/add-product' className='flex items-center p-2 hover:bg-gray-200'>
											<GrDocumentUpdate className='text-xl' />
											{!isSidebarCollapsed && <span className='ml-2'>Add Product</span>}
										</Link>
									</li>
									<li>
										<Link to='/product-list' className='flex items-center p-2 hover:bg-gray-200'>
											<GrDocumentTime className='text-xl' />
											{!isSidebarCollapsed && <span className='ml-2'>Product List</span>}
										</Link>
									</li>
								</ul>
							)}
						</li>
					</ul>
				</nav>
			</div>

			{/* Mobile Overlay */}
			{isMobileOpen && (
				<div
					className='fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden '
					onClick={toggleMobileSidebar}></div>
			)}
		</div>
	);
}

export default SideBar;
